import React from 'react'

export default function NiBell() {
  return (
    
<svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M7.14588 18.6797C5.25361 17.9701 4 16.1611 4 14.1402L4 13.6473C4 11.3056 4.46369 8.98715 5.36433 6.82563L5.65281 6.13327C6.49264 4.11769 8.29828 2.66633 10.4473 2.27951V2.27951C11.4742 2.09467 12.5258 2.09467 13.5527 2.27951V2.27951C15.7017 2.66633 17.5074 4.1177 18.3472 6.13327L18.6357 6.82564C19.5363 8.98716 20 11.3056 20 13.6473L20 14.1402C20 16.1611 18.7464 17.9701 16.8541 18.6797L16.5998 18.7751C13.6341 19.8872 10.3659 19.8872 7.40018 18.7751L7.14588 18.6797Z"
              stroke="currentColor"
              stroke-width="1.5"
            ></path>
            <path
              opacity="0.6"
              d="M15 19.5C13.8696 22.9376 10.1304 22.9376 9 19.5"
              stroke="currentColor"
              stroke-width="1.5"
              stroke-linecap="round"
            ></path>
          </svg>
  )
}
